import { StatisticsState } from "@app/types";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { BookInteraction } from "@app/types/dashboard.type";
import { memo, useEffect, useMemo, useState } from "react";
import DashboardService from "@app/services/http/dashboard.service";
import InteractionIcon from "@app/icons/dashboard/interaction";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

const BookInteractions = ({ filter }: { filter: StatisticsState }) => {
  const [data, setData] = useState<BookInteraction>({ items: [] });

  useEffect(() => {
    DashboardService.getBookInteractions({
      startDate: filter.startDate || undefined,
      endDate: filter.endDate || undefined,
    }).then((res) => {
      if (res.data.items.length) {
        setData(res.data);
      } else {
        setData({ items: [] });
      }
    });
  }, [filter.startDate, filter.endDate]);

  const chartData = useMemo(
    () => ({
      labels: data.items.map((item) => item.label),
      datasets: [
        {
          label: "Số lượt tim",
          data: data?.items.map((item) => item.totalLike),
          borderColor: "rgba(98, 112, 234, 1)",
          backgroundColor: "rgba(98, 112, 234, 0.2)",
          pointBackgroundColor: "rgba(98, 112, 234, 1)",
          pointBorderColor: "#fff",
          tension: 0.4,
          fill: true,
        },
        {
          label: "Số lượt share",
          data: data.items.map((item) => item.totalShare),
          borderColor: "rgba(235, 98, 98, 1)",
          backgroundColor: "rgba(235, 98, 98, 0.2)",
          pointBackgroundColor: "rgba(235, 98, 98, 1)",
          pointBorderColor: "#fff",
          tension: 0.4,
          fill: true,
        },
        {
          label: "Số lượt cmt",
          data: data.items.map((item) => item.totalComment),
          borderColor: "rgba(252, 176, 69, 1)",
          backgroundColor: "rgba(252, 176, 69, 0.2)",
          pointBackgroundColor: "rgba(252, 176, 69, 1)",
          pointBorderColor: "#fff",
          tension: 0.4,
          fill: true,
        },
        {
          label: "Số lượt nghe",
          data: data.items.map((item) => item.totalListen),
          borderColor: "rgba(52, 172, 224, 1)",
          backgroundColor: "rgba(52, 172, 224, 0.2)",
          pointBackgroundColor: "rgba(52, 172, 224, 1)",
          pointBorderColor: "#fff",
          tension: 0.4,
          fill: true,
        },
        {
          label: "Số lượt view",
          data: data.items.map((item) => item.totalView),
          borderColor: "rgba(23, 192, 120, 1)",
          backgroundColor: "rgba(23, 192, 120, 0.2)",
          pointBackgroundColor: "rgba(23, 192, 120, 1)",
          pointBorderColor: "#fff",
          tension: 0.4,
          fill: true,
        },
      ],
    }),
    [data]
  );

  return (
    <div className="p-[24px] bg-white rounded-xl flex flex-col gap-[40px]">
      <div className="flex gap-1 items-center">
        <InteractionIcon />
        <p className="text-[18px] text-[#45464E] font-medium">
          Tương tác trên sách
        </p>
      </div>
      <Line
        data={chartData}
        options={{
          responsive: true,
          plugins: {
            legend: {
              position: "bottom",
            },
            title: {
              display: false,
            },
          },
        }}
      />
    </div>
  );
};

export default memo(BookInteractions);
